import * as PIXI from "pixi.js";
import Main from "../Main";
import LayerGroup from "../layers/LayerGroup";
import { EnumEventBus, EventBus } from "../managers/EventBus";


export default class Game extends PIXI.Container {
  static instance: Game;
  private Main = Main.getInstance();
  private EventBus = EventBus;

  constructor() {
    super();
    if (!Game.instance) {
      Game.instance = this;
    }
    new LayerGroup();
    this.addToStage();
    this.EventBus.emit(EnumEventBus.setTotalWon, 0);
  }

  addToStage() {
    this.Main.stage.addChild(this);
  }

  static getInstance(): Game {
    return Game.instance;
  }
}
